<script>
import Base from '@backend/Base.vue';
import BOGen from '@helper/BOGen';
import BoConfig from '@config/BoConfig';

export default {
  extends: Base,
  data(){
    return {
      Name:"MrCostCenter",
      PageName: "Cost Center List",
      ObjectName: "Cost Center",
      AddItem: true,
      WithLimit: true,
      mrJobTitle: [],
      mrValidation: {
        msg_bg_id: "required",
        mcc_mjt_id: "required",
        mcc_costcenter: "required|minlength:3|maxlength:10",
        status: "required",
      },
      filter: {
        limit : 50,
      },
    }
  },
  mounted(){
    this.filter.limit = 50;
    this.$set(this.$root, 'page', this)
    this.refreshData()
    this.apiJobTitle();
  },
  methods:{
    apiJobTitle(){
      BOGen.apirest("/job-title-select", {}, (e,resp)=>{
        if(e) return console.error(e)
        this.mrJobTitle = resp.data
      })
    },
    resultDataCwid(data) {
      var items = [];
      data.data.forEach((x)=>{
        items.push({
          id: x.cwid,
          text: (x.cwid?x.cwid+" | ":"")+x.employeename+" "+(x.position?"("+x.position+")":""),
        })
      })
      return {results: items}
    },
  },
  watch:{
    '$route.query'(){ this.refreshData(); if(this.$route.params.id) this.row = {} },
  }
}
</script>

<template>
  <div class="container-fluid">
    <PageTitle></PageTitle>
    
    <!-- ======================================================================== 
      LIST DATA
    ============================================================================= -->
    <div class="card card-flat" v-if="!$route.params.id">
      <div class="card-body card-filter">
        <VForm @resp="search">
          <div class="row">
            <div class="col-sm-3">
              <h4 class="card-title">{{ObjectName}} List <span v-if="data.total">({{(data.total||0).format()}})</span></h4>
            </div>
            <div class="col-sm-3">
            </div>
            <div class="col-sm-2">
              <Select2 :options="BoConfig.mrPageLimit" v-model="filter.limit" @input="changeLimit"></Select2>
            </div>
            <div class="col-sm-3">
              <div class="has-feedback has-feedback-left">
                <input type="search" v-model="filter.search" @keyup.enter="search" class="form-control" placeholder="Type and hit Enter">
                <div class="form-control-feedback">
                  <i class="icon-search4 text-size-base text-muted"></i>
                </div>
              </div>
            </div>
            <div class="col-sm-1">
              <button type="button" @click="resetSearch()" class="btn btn-warning btn-sm">Reset</button>
            </div>
          </div>
        </VForm>
      </div>
      <div class="table-responsive ajax-table">
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th width="50px">#</th>
              <th><SortField name="division" :label="fields.msg_bg_id"></SortField></th>
              <th><SortField name="position" :label="fields.mjt_id"></SortField></th>
              <th><SortField name="costcenter" :label="fields.mcc_costcenter"></SortField></th>
              <th width="120px">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v,k) in data.data" :key="k">
              <td class="number">{{(data.per_page*(data.current_page-1))+k+1}}</td>
              <td>{{v.division||'-'}}</td>
              <td>{{v.position||'-'}}</td>
              <td>{{v.costcenter||'-'}}</td>
              <td class="btn-action">
                <router-link class="icon_action" :to="{name:Name,params:{id:v.id}}" v-tooltip="'Edit'"><i class="icon-pencil"></i></router-link>
                <a href="javascript:;" class="icon_action" @click="deleteItem($event,k)" v-tooltip="'Remove'"><i class="icon-trash"></i></a>
              </td>
            </tr>
            <tr v-if="NotFound">
              <td colspan="99">
                <h3 class="tc">{{NotFound}}</h3>
              </td>
            </tr>
            <tr v-if="data.data===false">
              <td colspan="99">
                <LoadingSpinner light></LoadingSpinner>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-body">
        <div class="pull-right">
          <Pagination :data="data" :limit="3" @pagination-change-page="onPaging"></Pagination>
        </div>
      </div>
    </div>

    <!-- ======================================================================== 
      FORM CRUD
    ============================================================================= -->
    <div class="card card-flat" v-if="$route.params.id">
      <VForm @resp="submitForm" method="post">
        <div class="card-body card-form">
          <h4 class="card-title">{{(row.id?"Edit":"Add")+" "+ObjectName}}</h4>
        </div>
        <div class="card-body">
          <div class="info"></div>
          <div class="row">
            <div class="col-sm-6">
              <BoField name="mcc_mjt_id">
                <Select2 :options="mrJobTitle" :object="['mjt_id','mjt_name']" name="mcc_mjt_id" v-model="row.mcc_mjt_id" v-bind="validation('mcc_mjt_id')" :disabled="row.id">
                  <option value="">-- Select Position Title --</option>
                </Select2>
              </BoField>              
            </div>

            <div class="col-sm-6">
              <BoField name="mcc_costcenter" v-model="row.mcc_costcenter"></BoField>
            </div>

            <div class="col-sm-12">
              <div class="text-right">
                <button type="button" @click="back()" class="btn btn-default mr5">Cancel</button>
                <button type="submit" class="fcbtn btn btn-info btn-outline btn-1e btn-loading">Submit form <i class="icon-arrow-right14 position-right"></i></button>
              </div>
            </div>
          </div>
        </div>
      </VForm>
    </div>
  </div>
</template>
